import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Ticket } from "lucide-react";

// Two cards for the interactive pages, shown near the top of the home page.
// data-umami-event lets Umami count clicks on each card.
const CARDS = [
  {
    to: "/find-a-show",
    tag: "Show finder",
    icon: Ticket,
    title: "Which show should I see?",
    text: "Tell us who is coming and what you enjoy, and we will pick three shows to suit, with prices and age guidance.",
    cta: "Find my show",
    event: "Home: show finder card",
  },
  {
    to: "/quiz",
    tag: "Quiz",
    icon: Sparkles,
    title: "Which West End role are you?",
    text: "Answer a few cheeky questions and find out which character you were born to play.",
    cta: "Take the quiz",
    event: "Home: role quiz card",
  },
];

export function InteractiveCards() {
  return (
    <div className="fade-up grid max-w-3xl gap-3 sm:grid-cols-2 lg:max-w-none lg:grid-cols-1">
      {CARDS.map(({ to, tag, icon: Icon, title, text, cta, event }) => (
        <Link
          key={to}
          to={to}
          data-umami-event={event}
          className="group flex flex-col rounded-2xl border border-[#C89B3C]/40 bg-[#0D0A0E]/65 p-5 backdrop-blur-sm transition-colors hover:border-[#C89B3C] hover:bg-[#0D0A0E]/80"
        >
          <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#C89B3C]">
            <Icon className="h-4 w-4" /> {tag}
          </span>
          <h3 className="mt-2 font-serif text-xl font-semibold text-amber-50">{title}</h3>
          <p className="mt-1.5 text-sm leading-6 text-amber-100/70">{text}</p>
          <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#C89B3C]">
            {cta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </span>
        </Link>
      ))}
    </div>
  );
}